module.exports = __webpack_public_path__ + "static/media/estimulo_manual.8753ef9c.png";